import { Clock } from './Clock';
export class AudioContextClock extends Clock {
    audioContext;
    startTime;
    constructor(audioContext) {
        super();
        this.audioContext = audioContext;
        this.startTime = audioContext.currentTime;
    }
    close() {
    }
    async _seek(time) {
        this.startTime = this.audioContext.currentTime - time;
        return this.now;
    }
    async _pause() {
        if (this.audioContext.state == 'running') {
            await this.audioContext.suspend();
        }
        return this.now;
    }
    async _end() {
        if (this.audioContext.state == 'running') {
            await this.audioContext.suspend();
        }
        return this.now;
    }
    async _resume() {
        if (this.audioContext.state == 'suspended') {
            await this.audioContext.resume();
        }
        return this.now;
    }
    get isRunning() {
        return this.audioContext.state == 'running';
    }
    get now() {
        return this.audioContext.currentTime - this.startTime;
    }
    timeAt(perfTime) {
        const { contextTime, performanceTime } = this.audioContext.getOutputTimestamp();
        if (this.isRunning) {
            if (contextTime !== undefined && performanceTime !== undefined) {
                return contextTime - this.startTime + (perfTime - performanceTime) / 1000;
            }
            else {
                const perfNow = performance.now();
                return this.now + (perfTime - perfNow) / 1000;
            }
        }
        else {
            return this.now;
        }
    }
}
//# sourceMappingURL=AudioContextClock.js.map